<template>
  <div class="enrolling-student-add" v-loading="loading" :element-loading-text="loadingText">
    <div class="main">
      <el-form>
        <el-descriptions class="margin-top" :column="3" border>
          <el-descriptions-item label="报考类型*" :span="3">
            <div class="descriptions-content">
              <el-select v-model="basicInfo.studentType"
                         size="mini"
                         :disabled="true"
                         filterable>
                <el-option v-for="studentType in studentTypeList"
                           :key="studentType.code"
                           :label="studentType.name"
                           :value="studentType.code"/>
              </el-select>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="姓名*" >
            <div class="descriptions-content name">
              <el-input v-model="basicInfo.trueName"></el-input>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="证件类型*" labelClassName="higher">
            <div class="descriptions-content">
              <el-select v-model="basicInfo.cardType"
                         size="mini"
                         filterable>
                <el-option v-for="cardType in cardTypeList"
                           :key="cardType.code"
                           :label="cardType.name"
                           :value="cardType.code"/>
              </el-select>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="证件号码*" >
            <div class="descriptions-content">
              <el-input v-model="basicInfo.cardNo"></el-input>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="性别*" >
            <div class="descriptions-content gender">
              <el-select v-model="basicInfo.gender"
                         size="mini"
                         filterable>
                <el-option v-for="gender in genderList"
                           :key="gender.code"
                           :label="gender.name"
                           :value="gender.code"/>
              </el-select>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="出生日期*" >
            <div class="descriptions-content">
              <el-date-picker
                v-model="basicInfo.birthday"
                :clearable="false"
                value-format="yyyy-MM-dd"
                format="yyyy 年 MM 月 dd 日"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="民族*" >
            <div class="descriptions-content">
              <el-select v-model="basicInfo.folk"
                         size="mini"
                         filterable>
                <el-option v-for="folk in folkList"
                           :key="folk.code"
                           :label="folk.name"
                           :value="folk.code"/>
              </el-select>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="籍贯*" >
            <div class="descriptions-content">
              <el-cascader v-model="basicInfo.origin" :options="provinceAndCityData" @change="changeOrigin">
              </el-cascader>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="所在地市*" >
            <div class="descriptions-content">
              <el-cascader v-model="basicInfo.fromRegion" :options="provinceAndCityData" @change="changeRegion">
              </el-cascader>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="政治面貌*" >
            <div class="descriptions-content">
              <el-select v-model="basicInfo.polity"
                         size="mini"
                         filterable>
                <el-option v-for="polity in polityList"
                           :key="polity.code"
                           :label="polity.name"
                           :value="polity.code"/>
              </el-select>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="参加工作时间*" >
            <div class="descriptions-content">
              <el-date-picker
                v-model="basicInfo.joinWorkDate"
                :clearable="false"
                value-format="yyyy-MM"
                format="yyyy 年 MM 月"
                type="month"
                placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="工作单位*" :span="2">
            <div class="descriptions-content">
              <el-input v-model="basicInfo.workUnit"></el-input>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="单位性质*" >
            <div class="descriptions-content">
              <el-select v-model="basicInfo.workUnitType"
                         size="mini"
                         filterable>
                <el-option v-for="workUnitType in workUnitTypeList"
                           :key="workUnitType.code"
                           :label="workUnitType.name"
                           :value="workUnitType.code"/>
              </el-select>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="所属行业*" >
            <div class="descriptions-content">
              <el-select v-model="basicInfo.industry"
                         size="mini"
                         filterable>
                <el-option v-for="industry in industryList"
                           :key="industry.code"
                           :label="industry.name"
                           :value="industry.code"/>
              </el-select>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="职级*" labelClassName="higher" >
            <div class="descriptions-content">
              <el-select v-model="basicInfo.jobLevel"
                         size="mini"
                         filterable>
                <el-option v-for="jobLevel in jobLevelList"
                           :key="jobLevel.code"
                           :label="jobLevel.name"
                           :value="jobLevel.code"/>
              </el-select>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="职称*" >
            <div class="descriptions-content">
              <el-select v-model="basicInfo.jobTitle"
                         size="mini"
                         filterable>
                <el-option v-for="jobTitle in jobTitleList"
                           :key="jobTitle.code"
                           :label="jobTitle.name"
                           :value="jobTitle.code"/>
              </el-select>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="职务*" labelClassName="higher" :span="2">
            <div class="descriptions-content">
              <el-input v-model="basicInfo.jobDuty"></el-input>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="手机*" >
            <div class="descriptions-content">
              <el-input v-model="basicInfo.mobilePhone"></el-input>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="电子信箱*" :span="2">
            <div class="descriptions-content">
              <el-input v-model="basicInfo.email"></el-input>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="紧急联系人*" >
            <div class="descriptions-content">
              <el-input v-model="basicInfo.emergencyContactName"></el-input>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="紧急联系方式*" :span="2">
            <div class="descriptions-content">
              <el-input v-model="basicInfo.emergencyContactPhone"></el-input>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="通信地址" >
            <div class="descriptions-content">
              <el-cascader v-model="basicInfo.addressRegionCodeArray"
                           :options="provinceCityAreaData" @change="changeRegionArray">
              </el-cascader>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="详细通信地址" :span="2">
            <div class="descriptions-content">
              <el-input v-model="basicInfo.address"></el-input>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="最终学历*">
            <div class="descriptions-content">
              <el-select v-model="basicInfo.degree"
                         size="mini"
                         filterable>
                <el-option v-for="degree in degreeList"
                           :key="degree.code"
                           :label="degree.name"
                           :value="degree.code"/>
              </el-select>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="毕业学校*" :span="2">
            <div class="descriptions-content">
              <el-input v-model="basicInfo.graduateSchool"></el-input>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="毕业日期*" >
            <div class="descriptions-content">
              <el-date-picker
                v-model="basicInfo.graduateDate"
                :clearable="false"
                value-format="yyyy-MM"
                format="yyyy年MM月"
                type="month"
                placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="毕业专业*" :span="2">
            <div class="descriptions-content">
              <el-input v-model="basicInfo.graduateMajor"></el-input>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="毕业证书编号" >
            <div class="descriptions-content">
              <el-input v-model="basicInfo.graduateNo"></el-input>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="报考教学点*" :span="isFlowBatch ? 2: 1">
            <div class="descriptions-content text-left">
              <el-select v-model="basicInfo.siteId"
                         size="mini"
                         filterable>
                <el-option v-for="site in siteList"
                           :key="site.id"
                           :label="site.name"
                           :value="site.id"/>
              </el-select>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="学生类型*" v-if="!isFlowBatch">
            <div class="descriptions-content text-left">
              <el-select v-model="basicInfo.enrollType"
                         size="mini"
                         filterable>
                <el-option label="新生" value="4"/>
                <el-option label="跟读生" value="2"/>
              </el-select>
            </div>
          </el-descriptions-item>
        </el-descriptions>
      </el-form>
      <div class="experience-container">
        <div class="title">学习与工作经历</div>
        <div class="table">
          <el-table
            :data="basicInfo.experiences"
            border
            style="width: 100%"
            @selection-change="handleSelectionChange">
            <el-table-column
              type="selection"
              width="40">
            </el-table-column>
            <el-table-column
              prop="date"
              label="开始日期"
              width="200"
              align="center">
              <template slot-scope="scope">
                <div class="table-center">
                  <div class="job-and-work-data-adjust">
                    <el-date-picker
                      v-model="scope.row.startDate"
                      :clearable="false"
                      type="month"
                      format="yyyy年MM月"
                      value-format="yyyy-MM">
                    </el-date-picker>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="date"
              label="结束日期"
              width="210"
              align="center">
              <template slot-scope="scope">
                <div class="table-center">
                  <div class="job-and-work-data-adjust">
                    <el-date-picker
                      v-model="scope.row.endDateValue"
                      :clearable="false"
                      :disabled="scope.row.isLockEndDate"
                      type="month"
                      format="yyyy年MM月"
                      value-format="yyyy-MM"
                      @change="changeExperienceEndDate(scope.row)"
                    >
                    </el-date-picker>
                    <el-checkbox v-model="scope.row.isLockEndDate" @change="changeLockEndTime(scope.row)">至今</el-checkbox>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="workUnit"
              label="学习经历或工作单位"
              width="300"
              align="center">
              <template slot-scope="scope">
                <div class="table-center">
                  <el-input v-model="scope.row.workUnit"></el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="workDuty"
              label="担任职务"
              min-width="200"
              align="center">
              <template slot-scope="scope">
                <div class="table-center">
                  <el-input v-model="scope.row.workDuty"></el-input>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="add-btn">
          <el-button @click="addExperience">添加一行</el-button>
          <el-button type="danger" @click="deleteExperience">删除选中行</el-button>
        </div>
      </div>
      <div class="experience-container" v-if="basicInfo.studentType === 'EMBA'">
        <div class="title">荣誉和论著</div>
        <div class="table">
          <el-table
            :data="basicInfo.honors"
            border
            style="width: 100%"
            @selection-change="handleHonorSelectChange">
            <el-table-column
              type="selection"
              width="40">
            </el-table-column>
            <el-table-column
              prop="honorName"
              label="名称"
              min-width="300"
              align="center">
              <template slot-scope="scope">
                <div class="table-center">
                  <el-input v-model="scope.row.honorName"></el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="honorUnitName"
              label="颁奖/认证机构"
              width="200"
              align="center">
              <template slot-scope="scope">
                <div class="table-center">
                  <el-input v-model="scope.row.honorUnitName"></el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="honorDate"
              label="获得/发表时间"
              width="200"
              align="center">
              <template slot-scope="scope">
                <div class="table-center">
                  <el-date-picker
                    v-model="scope.row.honorDate"
                    :clearable="false"
                    format="yyyy年MM月dd日"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="remark"
              label="特殊说明"
              width="200"
              align="center">
              <template slot-scope="scope">
                <div class="table-center">
                  <el-input v-model="scope.row.remark"></el-input>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="add-btn">
          <el-button @click="addHonor">添加一行</el-button>
          <el-button type="danger" @click="deleteHonor">删除选中行</el-button>
        </div>
      </div>
      <div class="exempt-write-container sub-form">
        <div class="title">免笔试申请</div>
        <div class="reason">
          <el-radio-group v-model="basicInfo.exemptWriteType" @change="changeExemptWriteType">
            <el-radio v-for="(type, index) in exemptWriteTypeList" :key="index" :label="type.code">{{ type.name }}</el-radio>
          </el-radio-group>
        </div>
        <div class="exempt-file" v-if="basicInfo.exemptWriteType !== '0'">
          <multi-upload v-model="exemptWriteImageList" :title="exemptWriteFilePathTitle" :limit="-1" ></multi-upload>
          <multi-upload v-model="exemptWrite1ImageList" :title="exemptWriteFileOnePathTitle" :limit="-1" v-if="basicInfo.exemptWriteType !== '4'"></multi-upload>
          <multi-upload v-model="exemptWrite2ImageList" :title="exemptWriteFileTwoPathTitle" :limit="-1" v-if="basicInfo.exemptWriteType === '1'" upload-type="pdf"></multi-upload>
        </div>
      </div>
      <div class="upload-container sub-form">
        <div class="title">上传材料</div>
        <div class="upload-file">
          <multi-upload v-model="basicInfo.cardPhotoPaths" title="身份证正反面" tips="(顺序：肖像面，国徽面)" :limit="2"></multi-upload>
          <multi-upload v-model="basicInfo.degreePhotoPaths" title="学历证书" :limit="-1" ></multi-upload>
          <single-upload v-model="basicInfo.userPhotoPath" title="个人照片"></single-upload>
          <multi-upload v-model="basicInfo.recommendLetterPaths" title="推荐信" :limit="2" v-if="basicInfo.studentType === 'EMBA'" upload-type="document"></multi-upload>
        </div>
      </div>
    </div>
    <div class="footer">
      <el-button type="primary" @click="save">提交保存</el-button>
      <el-button @click="close">关闭窗口</el-button>
    </div>
  </div>
</template>

<script>
import {
  provinceAndCityData,
  provinceCityAreaData,
  CodeToText
} from '../../../../../../../util/address/app.js'
import multiUpload from '../multiUpload.vue'
import singleUpload from '../singleUpload.vue'
import checkUtils from '../../../../../../../util/checkUtils'

export default {
  name: 'EnrollingStudentAdd',
  components: {
    multiUpload,
    singleUpload
  },
  props: {
    visible: Boolean,
    extraParams: Object
  },
  data () {
    return {
      provinceAndCityData,
      provinceCityAreaData,
      loading: false,
      loadingText: '加载中，请稍等...',
      basicInfo: {
        studentType: this.extraParams.studentType,
        trueName: '',
        cardType: '1',
        cardNo: '',
        gender: '',
        birthday: '',
        origin: [],
        originProvinceCode: '',
        originProvinceName: '',
        originCityCode: '',
        originCityName: '',
        fromRegion: [],
        regionProvinceCode: '',
        regionProvinceName: '',
        regionCityCode: '',
        regionCityName: '',
        joinWorkDate: '',
        workUnit: '',
        mobilePhone: '',
        email: '',
        emergencyContactName: '',
        emergencyContactPhone: '',
        address: '',
        experiences: [{
          startDate: '',
          endDate: '',
          endDateValue: '',
          workUnit: '',
          workDuty: '',
          isLockEndDate: false
        }],
        honors: [],
        cardPhotoPaths: [],
        degreePhotoPaths: [],
        recommendLetterPaths: [],
        userPhotoPath: '',
        exemptWriteType: '0',
        exemptWriteFilePath: '',
        exemptWriteFilePath1: '',
        addressRegionCode: '',
        addressRegionName: '',
        addressRegionCodeArray: [],
        exemptWriteFilePath2: '',
        polity: '',
        industry: '',
        jobTitle: '',
        jobLevel: '',
        degree: '',
        folk: '',
        workUnitType: '',
        jobDuty: '',
        graduateDate: '',
        graduateNo: '',
        graduateSchool: '',
        graduateMajor: '',
        enrollType: ''
      },
      exemptWriteImageList: [],
      exemptWrite1ImageList: [],
      exemptWrite2ImageList: [],
      selectExperience: [],
      selectHonor: [],
      genderList: [],
      folkList: [],
      polityList: [],
      workUnitTypeList: [],
      industryList: [],
      jobTitleList: [],
      jobLevelList: [],
      degreeList: [],
      exemptWriteTypeList: [],
      siteList: [],
      cardTypeList: [],
      studentTypeList: [],
      isFlowBatch: false
    }
  },
  computed: {
    exemptWriteFilePathTitle () {
      if (this.basicInfo && this.basicInfo.exemptWriteType === '1') {
        return '副高证书照片'
      } else if (this.basicInfo && this.basicInfo.exemptWriteType === '2') {
        return '硕士毕业证书信息页照片'
      } else if (this.basicInfo && this.basicInfo.exemptWriteType === '3') {
        return '国考准考证照片'
      } else if (this.basicInfo && this.basicInfo.exemptWriteType === '4') {
        return '立功受奖证书信息页或专业技术职务资格证书照片'
      } else {
        return '免考材料'
      }
    },
    exemptWriteFileOnePathTitle () {
      if (this.basicInfo && this.basicInfo.exemptWriteType === '1') {
        return '最后学历照片'
      } else if (this.basicInfo && this.basicInfo.exemptWriteType === '2') {
        return '硕士学位证书信息页照片'
      } else if (this.basicInfo && this.basicInfo.exemptWriteType === '3') {
        return '国考成绩照片'
      } else {
        return '免考材料'
      }
    },
    exemptWriteFileTwoPathTitle () {
      if (this.basicInfo && this.basicInfo.exemptWriteType === '1') {
        return '单位证明'
      } else {
        return '免考材料'
      }
    }
  },
  methods: {
    loadData () {
      this.loadingText = '加载中，请稍等...'
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/enrolling/student/prepareAddInfo',
        method: 'post',
        data: this.$qs.stringify({
          studentType: this.extraParams.studentType
        })
      }).then(res => {
        let data = res.data
        if (data) {
          if (data.responseCode === 'SUCCESS') {
            this.genderList = data.genderList
            this.folkList = data.folkList
            this.polityList = data.polityList
            this.workUnitTypeList = data.workUnitTypeList
            this.industryList = data.industryList
            this.jobTitleList = data.jobTitleList
            this.jobLevelList = data.jobLevelList
            this.degreeList = data.degreeList
            this.exemptWriteTypeList = data.exemptWriteTypeList
            this.siteList = data.siteList
            this.cardTypeList = data.cardTypeList
            this.studentTypeList = data.studentTypeList
            this.isFlowBatch = data.isFlowBatch
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    CodeToText (code) {
      return CodeToText[code]
    },
    changeOrigin (val) {
      this.basicInfo.originProvinceCode = val[0]
      this.basicInfo.originProvinceName = this.CodeToText(val[0])
      this.basicInfo.originCityCode = val[1]
      this.basicInfo.originCityName = this.CodeToText(val[1])
    },
    changeRegion (val) {
      this.basicInfo.regionProvinceCode = val[0]
      this.basicInfo.regionProvinceName = this.CodeToText(val[0])
      this.basicInfo.regionCityCode = val[1]
      this.basicInfo.regionCityName = this.CodeToText(val[1])
    },
    changeRegionArray (val) {
      let array = []
      if (val && val.length) {
        provinceCityAreaData.map((item) => {
          if (item && item.value && item.value === val[0]) {
            array.push({
              label: item.label,
              value: val[0]
            })
            if (item && item.children && item.children.length) {
              item.children.map((cityItem) => {
                if (cityItem && cityItem.value === val[1] && val[1]) {
                  array.push({
                    label: cityItem.label,
                    value: val[1]
                  })
                  if (cityItem.children && cityItem.children.length) {
                    cityItem.children.map((countyItem) => {
                      if (countyItem && countyItem.value === val[2] && val[2]) {
                        array.push({
                          label: countyItem.label,
                          value: val[2]
                        })
                      }
                    })
                  }
                }
              })
            }
          }
        })
      }
      if (array && array.length) {
        array.map((item, index) => {
          if (item && item.value) {
            if (index === 0) {
              this.basicInfo.addressRegionCode = item.value
              this.basicInfo.addressRegionName = item.label
            } else {
              this.basicInfo.addressRegionName = this.basicInfo.addressRegionName + ',' + item.label
              this.basicInfo.addressRegionCode = this.basicInfo.addressRegionCode + ',' + item.value
            }
          }
        })
      } else {
        this.basicInfo.addressRegionCode = ''
        this.basicInfo.addressRegionName = ''
      }
    },
    changeExperienceEndDate (item) {
      item.endDate = item.endDateValue
    },
    changeLockEndTime (item) {
      item.endDateValue = ''
      item.endDate = ''
      if (item.isLockEndDate) {
        item.endDate = '至今'
      }
    },
    addExperience () {
      this.basicInfo.experiences.push({
        startDate: '',
        endDate: '',
        endDateValue: '',
        workDuty: '',
        workUnit: ''
      })
    },
    deleteExperience () {
      if (this.selectExperience.length === 0) {
        this.$message.error('请选择要删除的行')
        return
      }
      if (this.selectExperience.length === this.basicInfo.experiences.length) {
        this.$message.error('至少保留一行')
        return
      }
      this.selectExperience.forEach(item => {
        this.basicInfo.experiences = this.basicInfo.experiences.filter(ele => {
          return ele !== item
        })
      })
    },
    handleSelectionChange (val) {
      this.selectExperience = val
    },
    addHonor () {
      this.basicInfo.honors.push({
        honorName: '',
        honorUnitName: '',
        honorDate: '',
        remark: ''
      })
    },
    deleteHonor () {
      this.selectHonor.forEach(item => {
        this.basicInfo.honors = this.basicInfo.honors.filter(ele => {
          return ele !== item
        })
      })
    },
    handleHonorSelectChange (val) {
      this.selectHonor = val
    },
    changeExemptWriteType () {
      this.exemptWriteImageList = []
      this.exemptWrite1ImageList = []
      this.exemptWrite2ImageList = []
    },
    save () {
      if (!this.basicInfo.studentType) {
        this.$message.error('报考类型不能为空')
        return
      } else if (!this.basicInfo.trueName) {
        this.$message.error('姓名不能为空')
        return
      } else if (!this.basicInfo.cardType) {
        this.$message.error('证件类型不能为空')
        return
      } else if (!this.basicInfo.cardNo) {
        this.$message.error('证件号码不能为空')
        return
      } else if (this.basicInfo.cardType === '1' && !checkUtils.isIdCard(this.basicInfo.cardNo)) {
        this.$message.error('身份证号不合法')
        return
      } else if (!this.basicInfo.gender) {
        this.$message.error('性别不能为空')
        return
      } else if (!this.basicInfo.birthday) {
        this.$message.error('出生日期不能为空')
        return
      } else if (!this.basicInfo.folk) {
        this.$message.error('民族不能为空')
        return
      } else if (!this.basicInfo.origin[0]) {
        this.$message.error('籍贯不能为空')
        return
      } else if (!this.basicInfo.origin[1]) {
        this.$message.error('籍贯不能为空')
        return
      } else if (!this.basicInfo.fromRegion[0]) {
        this.$message.error('所在地市不能为空')
        return
      } else if (!this.basicInfo.fromRegion[1]) {
        this.$message.error('所在地市不能为空')
        return
      } else if (!this.basicInfo.polity) {
        this.$message.error('政治面貌不能为空')
        return
      } else if (!this.basicInfo.joinWorkDate) {
        this.$message.error('参加工作时间不能为空')
        return
      } else if (!this.basicInfo.workUnit) {
        this.$message.error('工作单位不能为空')
        return
      } else if (!this.basicInfo.workUnitType) {
        this.$message.error('单位性质不能为空')
        return
      } else if (!this.basicInfo.industry) {
        this.$message.error('所属行业不能为空')
        return
      } else if (!this.basicInfo.jobLevel) {
        this.$message.error('职级不能为空')
        return
      } else if (!this.basicInfo.jobDuty) {
        this.$message.error('请填写职务')
        return
      } else if (!this.basicInfo.jobTitle) {
        this.$message.error('请填写职称')
        return
      } else if (!this.basicInfo.mobilePhone) {
        this.$message.error('手机不能为空')
        return
      } else if (!checkUtils.isMobilePhone(this.basicInfo.mobilePhone)) {
        this.$message.error('手机格式不正确')
        return
      } else if (!this.basicInfo.email) {
        this.$message.error('电子邮箱不能为空')
        return
      } else if (!checkUtils.isEmail(this.basicInfo.email)) {
        this.$message.error('电子邮箱格式不正确')
        return
      } else if (!this.basicInfo.emergencyContactName) {
        this.$message.error('紧急联系人不能为空')
        return
      } else if (!this.basicInfo.emergencyContactPhone) {
        this.$message.error('紧急联系方式不能为空')
        return
      } else if (!checkUtils.isMobilePhone(this.basicInfo.emergencyContactPhone)) {
        this.$message.error('紧急联系方式格式不正确')
        return
      } else if (!this.basicInfo.degree) {
        this.$message.error('请填写最终学历')
        return
      } else if (!this.basicInfo.graduateSchool) {
        this.$message.error('请填写毕业学校')
        return
      } else if (!this.basicInfo.graduateMajor) {
        this.$message.error('请填写毕业专业')
        return
      } else if (!this.basicInfo.graduateDate) {
        this.$message.error('请填写毕业日期')
        return
      } else if (!this.basicInfo.siteId) {
        this.$message.error('报考学校不能为空')
        return
      }
      if (!this.isFlowBatch && !this.basicInfo.enrollType) {
        this.$message.error('学生类型不能为空')
        return
      }

      for (let i = 0; i < this.basicInfo.experiences.length; i++) {
        let experience = this.basicInfo.experiences[i]
        if (!experience.startDate || !experience.endDate || !experience.workUnit || !experience.workDuty) {
          this.$message.error('请完善学习与工作经历')
          return
        }
      }
      for (let i = 0; i < this.basicInfo.honors.length; i++) {
        let honor = this.basicInfo.honors[i]
        if (!honor.honorName || !honor.honorUnitName || !honor.honorDate) {
          this.$message.error('请完善荣誉或论著')
          return
        }
      }
      this.basicInfo.exemptWriteFilePath = this.exemptWriteImageList && this.exemptWriteImageList.length ? this.exemptWriteImageList.join(',') : ''
      this.basicInfo.exemptWriteFilePath1 = this.exemptWrite1ImageList && this.exemptWrite1ImageList.length ? this.exemptWrite1ImageList.join(',') : ''
      this.basicInfo.exemptWriteFilePath2 = this.exemptWrite2ImageList && this.exemptWrite2ImageList.length ? this.exemptWrite2ImageList.join(',') : ''
      if (!this.basicInfo.exemptWriteType) {
        this.$message.error('申请免入学笔试理由不能为空')
        return
      } else if (!this.basicInfo.exemptWriteFilePath && this.basicInfo.exemptWriteType !== '0') {
        this.$message.error('免试材料不能为空')
        return
      } else if (!this.basicInfo.exemptWriteFilePath1 && this.basicInfo.exemptWriteType !== '0' && this.basicInfo.exemptWriteType !== '4') {
        this.$message.error('免考材料缺失')
        return
      } else if (!this.basicInfo.exemptWriteFilePath2 && this.basicInfo.exemptWriteType === '1') {
        this.$message.error('免考材料缺失')
        return
      } else if (!this.basicInfo.cardPhotoPaths[0] || !this.basicInfo.cardPhotoPaths[1]) {
        this.$message.error('请上传身份证正反面')
        return
      } else if (!this.basicInfo.degreePhotoPaths[0]) {
        this.$message.error('学历证书不能为空')
        return
      } else if (!this.basicInfo.userPhotoPath) {
        this.$message.error('个人照片不能为空')
        return
      } else if (this.basicInfo.studentType === 'EMBA' && !this.basicInfo.recommendLetterPaths && !this.basicInfo.recommendLetterPaths[0] && !this.basicInfo.recommendLetterPaths[1]) {
        this.$message.error('请上传两封推荐信')
        return
      }
      this.loadingText = '保存中，请稍等...'
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/enrolling/student/addStudent',
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(this.basicInfo)
      }).then(response => {
        if (response.data) {
          if (response.data.responseCode === 'SUCCESS') {
            this.$message.success('保存成功')
            this.$emit('hidePopoverAndRefresh')
          } else {
            this.$message.error(response.data.message || '保存失败')
          }
        }
      }, () => {
        this.$message.error('保存失败')
      }).finally(() => {
        this.loading = false
      })
    },
    close () {
      this.$emit('hidePopover')
    },
    restForm () {
      this.basicInfo = {
        studentType: '',
        trueName: '',
        cardType: '1',
        cardNo: '',
        gender: '',
        birthday: '',
        origin: [],
        originProvinceCode: '',
        originProvinceName: '',
        originCityCode: '',
        originCityName: '',
        fromRegion: [],
        regionProvinceCode: '',
        regionProvinceName: '',
        regionCityCode: '',
        regionCityName: '',
        joinWorkDate: '',
        workUnit: '',
        mobilePhone: '',
        email: '',
        emergencyContactName: '',
        emergencyContactPhone: '',
        address: '',
        experiences: [{
          startDate: '',
          endDate: '',
          endDateValue: '',
          workUnit: '',
          workDuty: '',
          isLockEndDate: false
        }],
        honors: [],
        cardPhotoPaths: [],
        degreePhotoPaths: [],
        userPhotoPath: '',
        recommendLetterPaths: [],
        exemptWriteType: '0',
        exemptWriteFilePath: '',
        exemptWriteFilePath1: '',
        addressRegionCode: '',
        addressRegionName: '',
        addressRegionCodeArray: [],
        exemptWriteFilePath2: '',
        polity: '',
        industry: '',
        jobTitle: '',
        jobLevel: '',
        degree: '',
        folk: '',
        workUnitType: '',
        jobDuty: '',
        graduateDate: '',
        graduateNo: '',
        graduateSchool: '',
        graduateMajor: '',
        enrollType: ''
      }
      this.exemptWriteImageList = []
      this.exemptWrite1ImageList = []
      this.exemptWrite2ImageList = []
    }
  },
  mounted () {
    this.loadData()
  },
  watch: {
    visible: function (value) {
      if (value) {
        this.restForm()
      }
    }
  }
}
</script>

<style lang="scss">
.enrolling-student-add {
  height: 100%;
  .main {
    padding: 10px;
    background-color: #fff;
    height: calc(100% - 60px);
    overflow: auto;
    & > .el-form {
      .el-select .el-input, .el-cascader .el-input {
        width: 220px;
      }
    }
    & > .experience-container {
      & > .title {
        height: 35px;
        font-weight: 400;
        line-height: 35px;
        color: #909399;
        text-align: center;
        background-color: #fafafa;
        border-left: 1px solid #EBEEF5;
        border-right: 1px solid #EBEEF5;
      }
      & > .table {
        .el-date-editor.el-input, .el-date-editor.el-input__inner {
          width: 129px !important;
        }
      }
      & > .add-btn {
        height: 50px;
        padding: 10px;
        border: 1px solid #EBEEF5;
        border-top: none;
        display: flex;
        justify-content: center;
      }
    }
    & > .sub-form {
      border: 1px solid #EBEEF5;
      border-top: none;
      & > .title {
        height: 35px;
        font-weight: 400;
        line-height: 35px;
        color: #909399;
        text-align: center;
        background-color: #fafafa;
        border-bottom: 1px solid #EBEEF5;
      }
    }
    & > .exempt-write-container {
      & > .reason {
        padding: 10px;
      }
      & > .exempt-file {}
    }
    & > .upload-container {
      & > .upload-file {}
    }
  }
  .footer {
    height: 60px;
    padding: 15px;
    border-top: 1px solid rgba(0,0,0,0.03);
    text-align: center;
  }
}
</style>
